// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-modal-sidebar',
    // #endregion
    // #region Properties
    props: {
        id: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: ''
        },
        variant: {
            type: String,
            required: false,
            default: 'default',
            validValues: ['default', 'small', 'large', 'full'],
            validator(value) {
                if (!value.length) {
                    return true;
                }
                return ['default', 'small', 'large', 'full'].includes(value);
            }
        },
        closeOnKeyEsc: {
            type: Boolean,
            required: false,
            default: true
        },
        closeOnOutsideClick: {
            type: Boolean,
            required: false,
            default: true
        },
        closable: {
            type: Boolean,
            required: false,
            default: true
        },
        classes: {
            type: [Array],
            default() {
                return [];
            }
        }
    },
    data: () => ({
        visible: false
    }),
    computed: {
        modalClass() {
            const classes = this.classes.reduce(function (result, item, index) {
                result[index] = true;
                return result;
            }, {});
            return {
                'modal-module__is-visible___2wKcA': true,
                'is-visible': true,
                'side-modal': true,
                'modal-module__side-modal___3cUif': true,
                ...classes
            };
        },
        modalStyle() {
            return {
                width: '300px',
            };
        },
        modalClasses() {
            return {
                [`g-modal--${this.variant}`]: (this.variant && !this.size)
            };
        },
        identifierClass() {
            return `g-modal--${this.id}`;
        },
        hasFooterSlot() {
            return !!this.$slots['modal-footer'];
        }
    },
    // #endregion
    // #region Constructor
    created() {
        this.show();
    },
    mounted() {
        this.setFocusToModal();
    },
    // #endregion
    // #region Core
    methods: {
        setFocusToModal() {
            /*                this.$el.querySelector('.g-modal__dialog').focus();*/
        },
        show() {
            this.visible = true;
        },
        close() {
            host.notification.closeModal(this.id);
        },
        closeModalOnClickOutside(domEvent) {
            //vars
            let tDialog = this.$refs.dialog;
            //Check
            if (!this.closeOnOutsideClick) {
                return;
            }
            if (utils.isNull(tDialog)) {
                return;
            }
            if (tDialog.contains(domEvent.target)) {
                return;
            }
            //Close
            this.close();
        },
        closeModalOnEscapeKey(event) {
            //Check
            if (!this.closeOnKeyEsc) {
                return;
            }
            if (event.target !== document.activeElement) {
                return;
            }
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.close();
            }
        }
    }
    // #endregion
});
// #endregion
